import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

interface RedirectRouteProps {
  to: string;
}

export const RedirectRoute: React.FC<RedirectRouteProps> = ({ to }) => {
  const params = useParams();
  const location = useLocation();

  let targetPath = to;

  Object.entries(params).forEach(([key, value]) => {
    targetPath = targetPath.replace(`:${key}`, value || '');
  });

  if (location.search) {
    targetPath += location.search;
  }

  return <Navigate to={targetPath} replace />;
};
